var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"content-row px-3 mb-3",attrs:{"id":"privacy-container","cols":"12"}},[_c('BackArrow',{staticClass:"my-3",on:{"back":function($event){return _vm.$emit('back')}}}),_c('b-row',{attrs:{"no-gutters":""}},[_c('PrivacyTextDe',{on:{"showBanner":function($event){return _vm.$bvModal.show('cookie-modal')}}})],1),_c('CookieModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }